<template>
  <b-container data-app fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-file"></i>
          Respuestas a la encuesta
          <span v-if="surveyStore">({{ surveyStore.name }})</span>
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="primary" @click="goToSurveyStore">{{
          $t(
            "public.views.Pages.Professional.Organization.HistoricClinics.btnBack"
          )
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <v-card-title>
          <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
            <template slot="label">{{
              $t("public.views.Pages.Professional.Organization.Survey.search")
            }}
            </template>
          </v-text-field>
        </v-card-title>

        <v-data-table :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-arrow-left',
          lastIcon: 'fas fa-arrow-right',
          prevIcon: 'fas fa-minus',
          nextIcon: 'fas fa-plus',
          'items-per-page-options': [10, 25, 50],
        }" :headers="headers" :items="surveys" :items-per-page="10" :search="search" item-key="uuid">
          <template v-slot:item.date="{ item }">
            <div v-if="item.date">
              {{ item.date | adjustToTimezone("DD/MM/YYYY HH:mm") }}
            </div>
          </template>
          <template v-slot:item.patient="{ item }">
            <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">
              <b-avatar v-bind:src="
                item.patient.avatarUrl
                  ? item.patient.avatarUrl +
                  '/' +
                  getAuthentication()
                  : ''
              "></b-avatar>
              <div class="media-support-info ml-3">
                <p class="mb-0 font-size-16">{{ item.patient.name }}</p>
                <p class="mb-0 font-size-12">{{ item.patient.lastname }}</p>
              </div>
            </b-list-group-item>
          </template>
          <template v-slot:item.surveyQuestions="{ item }">
            <span v-if="item.surveyQuestions && item.surveyQuestions.length === 0" class="badge badge-danger">
              Pendiente contestación
            </span>
            <span v-else class="badge badge-success"> Contestado </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="div-table-data">
              <button :id="'btnSee' + item.id" class="item" v-on:click="showSurvey(item.id, item.templateUuid)">
                <i class="ri-eye-line"></i>
              </button>
              <b-popover :target="'btnSee' + item.id" placement="botton" triggers="hover focus">
                <template #title>Ver respuesta</template>
              </b-popover>
            </div>
          </template>
        </v-data-table>
      </template>
    </iq-card>
  </b-container>
</template>

<script>
import { xray } from "../../../../config/pluginInit";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import SurveyBuilder from "../../../../components/survey/SurveyBuilderSurvey";
import SurveyEngineBuilder from "../../../../components/survey/SurveyBuilderEngineSurvey";
import QuestionsView from "../../../../components/survey/QuestionsView";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import surveyService from "../../../../services/survey";
import utilsService from "../../../../services/utils";

export default {
  name: "Survey",
  mounted() {
    xray.index();
    if (this.$route.query.surveyStoreId) {
      this.getSurveyStore(this.$route.query.surveyStoreId);
      this.getSurveysBySurveyStore(this.$route.query.surveyStoreId);

      utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_SURVEY_STORE", info: "" });
    } else {
      this.goToDashboard();
    }
  },
  computed: {},
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    showSurvey(id, templateUuid) {
      this.$router.push({
        name: "auth.professional.contact.surveyResponse",
        query: {
          surveyId: id,
          templateUuid: templateUuid,
          surveyStoreId: this.$route.query.surveyStoreId,
        },
      });
    },
    getSurveyStore(id) {
      let self = this;
      this.$awn.asyncBlock(
        surveyService.getStore(id),
        (response) => {
          if (response) {
            console.log(response.data);
            self.surveyStore = response.data;
          }
        },
        (error) => {

          utilsService.auditErrorFrontent({
            info: "surveyService.getStore",
            module: "view-pages-professional-contact-surveys",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    goToSurveyStore() {
      this.$router.push({
        name: "auth.professional.contact.survey",
      });
    },
    goToDashboard() {
      this.$router.push({
        name: "auth.professional.dashboard",
      });
    },
    getSurveysBySurveyStore(surveyStoreId) {
      let self = this;

      this.$awn.asyncBlock(
        surveyService.getSurveysBySurveyStore(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          surveyStoreId
        ),
        (response) => {
          if (response) {
            self.surveys = response.data.content;
            self.total = response.data.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.getSurveysBySurveyStore",
            module: "view-pages-professional-contact-surveys",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              surveyStoreId: surveyStoreId
            })
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      surveyStore: null,
      headers: [
        {
          text: "Fecha",
          align: "start",
          value: "date",
        },
        {
          text: "Paciente",
          value: "patient",
        },
        {
          text: "Estado",
          value: "surveyQuestions",
        },
        { text: "", value: "actions" },
      ],
      //Tablas
      search: "",
      surveys: [],
      total: 0,
      pagination: {},
      pageSize: 10,
      currentPage: 1,
    };
  },
  components: {
    VueTimepicker,
    DatePicker,
    Multiselect,
    SurveyBuilder,
    SurveyEngineBuilder,
    QuestionsView,
    "vue-dropzone": vue2Dropzone,
  },
};
</script>
